import { useEffect, useState } from "react";
import { isCardsReady } from "@dm-online/shared";
import { loadCards } from "@/lib/cardsLoader";
import { Button } from "@/components/ui/button";

// カードマスタの読み込みが終わるまで子を描画しない（子は getCardById 等を同期で呼ぶため）。
export function CardsGate({ children }: { children: React.ReactNode }) {
  const [ready, setReady] = useState(isCardsReady());
  const [error, setError] = useState<string | null>(null);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    if (ready) return;
    let cancelled = false;
    setError(null);
    loadCards().then(
      () => { if (!cancelled) setReady(true); },
      (e) => { if (!cancelled) setError(e instanceof Error ? e.message : "カードデータの取得に失敗しました"); },
    );
    return () => { cancelled = true; };
  }, [ready, attempt]);

  if (ready) return <>{children}</>;
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center text-muted-foreground">
      {error ? (
        <>
          <p>{error}</p>
          <Button onClick={() => setAttempt((n) => n + 1)}>再読み込み</Button>
        </>
      ) : (
        <p>カードデータを読み込み中…</p>
      )}
    </div>
  );
}
